import { v4 as uuidv4 } from 'uuid';

export function DisclosureTrigger(props = {}, childrenComponents = []) {
	return {
		componentName: 'DisclosureTrigger',
		componentId: uuidv4(),
		props: Object.assign(
			{
				as: 'button',
				Show: '',
				Hide: '',
			},
			props,
		),
		childrenComponents,
	};
}
